import brain from 'assets/images/brain.svg'

import { Container } from './styled'
import PolarAreaWithAngle from 'views/components/Graphics/PolarAreaWithAngle'
import { Ideal } from 'views/containers/TeamMap/BrainGraphicContainer'

interface ChildhoodAndYouth {
  FI: number
  FD: number
  BI: number
  BD: number
}
interface IProps {
  idealProfile?: Ideal
  showPolarArea: boolean
  dominantQuadrant?: string
  childhood?: ChildhoodAndYouth
  FI: number
  BI: number
  BD: number
  FD: number
  comparisonResult?: {
    FI: number
    BI: number
    BD: number
    FD: number
  }
  resultColor?: string
  resultLabel?: string
  comparisonResultLabel?: string
}

function isReadyIdealProfile(idealProfile: Ideal) {
  const { FI, BI, BD, FD } = idealProfile
  return FI > 0 && BI > 0 && BD > 0 && FD > 0
}

const BrainMetrics = ({
  FI,
  BI,
  BD,
  FD,
  idealProfile,
  showPolarArea,
  dominantQuadrant,
  childhood,
  comparisonResult,
  resultColor = '#C6016B',
  resultLabel = 'Medición original',
  comparisonResultLabel = 'Follow-Up',
}: IProps) => {
  const renderChart = (result: { FI: number; BI: number; BD: number; FD: number }, color: string) => (
    <PolarAreaWithAngle
      showPolarArea={showPolarArea}
      width={comparisonResult ? '480px' : '360px'}
      profileIdeal={idealProfile && isReadyIdealProfile(idealProfile) ? idealProfile : {}}
      FI={result.FI}
      BI={result.BI}
      BD={result.BD}
      FD={result.FD}
      resultColor={color}
      dominantQuadrant={dominantQuadrant}
      childhood={childhood}
      comparisonResult={comparisonResult}
      resultLabel={resultLabel}
      comparisonLabel={comparisonResultLabel}
    />
  )

  return (
    <Container
      style={{
        position: 'relative',
        backgroundImage: `url(${brain})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        marginTop: '20px',
      }}
    >
      {renderChart({ FI, BI, BD, FD }, resultColor)}
    </Container>
  )
}

export default BrainMetrics
